export default "__VITE_ASSET__CwcUURFh__"